@if (displayModal) {
  <app-modal [header]="'Dados do Utilizador'"
    [isShow]="displayModal"
    [style]="'w-full max-w-lg'"
    (cancel)="displayModal = false; onCancelModalEmitter.emit()">
    <div class="flex items-center max-w-md">
      <!-- Profile Image -->
      <i class=" align-top bg-blue-300 p-8  rounded pi pi-user text-white"></i>
      <!-- Right Section -->
      <div class="ml-4 flex flex-col space-y-2 w-full">
        <!-- Full Name -->
        <div class="font-medium text-lg">{{ user.firstname }} {{ user.lastname }}</div>
        <!-- Email Address -->
        <div class="text-gray-600 text-sm">{{ user.email }}</div>
        <!-- contact Number -->
        @if (user?.phoneNumber) {
          <div class="text-gray-600 text-sm">{{ user.phoneNumberCode }}{{ user.phoneNumber }}
          </div>
        }
        <!-- Creation Date & Status -->
        <div class="flex justify-between items-center">
          <!-- Creation Date -->
          <div class="text-gray-500 text-sm">Utilizador desde {{ user.creationDate | date: "dd-mm-yyyy" }}</div>
          <!-- Status -->
          <div class="bg-green-100 text-green-800 text-xs font-semibold px-2 py-1 rounded">
            {{ user.status.description }}
          </div>
        </div>
      </div>
    </div>
  </app-modal>
}

